import React, { lazy, Suspense, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";

// IMG Y IMPORTACIONES
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { Divider } from "@mui/material";

import useNews from "../hooks/useNews";

const ShareSocial = lazy(() => import("../components/news/ShareSocial"));
const CardNews = lazy(() => import("../components/news/CardNews"));
const NavTensoNews = lazy(() => import("../components/nav/NavTensoNews"));
const CardVideo = lazy(() => import("../components/news/CardVideo"));

const Noticias = ({pendientes, auditoria}) => {
  const params = useParams()
  const {news, obtenerNoticia, noticia, newsVideo} = useNews()
  const [busqueda, setBusqueda] = useState()
  const [titlePage, setTitlePage] = useState("")
  const [loading, setLoading] = useState(true)
  
  const navigate = useNavigate();

  useEffect(() => {
    const newTitle = params?.id?.replaceAll("-", " ")
    obtenerNoticia({title: newTitle})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  useEffect(() => {
    if(auditoria === true) {
    const newTitle = pendientes?.changes?.title
    obtenerNoticia({title: newTitle})
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendientes])

  useEffect(() => {
    setBusqueda(noticia.category);
  }, [noticia]);

  //Title de pageHtml
  setTimeout(() => {
    setTitlePage(noticia?.title);
  }, 500);
  useEffect(() => {
    document.title = titlePage ? titlePage : "Tensolite";
  }, [titlePage]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    if (noticia.publish === false ||noticia.visible === false) {
      navigate('/error404', { replace: true, state: { status: 404 } });
    }
  }, [noticia])

  return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>{noticia.title}</title>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="description" content={noticia?.title} />
          {/* Open Graph / Facebook */}
          <meta property="og:type" content="website" />
          <meta property="og:url" content={`http://tensolite.com/noticias/${noticia.title}`} />
          <meta property="og:title" content={noticia?.title} />
          <meta property="og:description" content={noticia?.top} />
          <meta property="og:image" content="/logo192.png" />
          {/* Twitter */}
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={`http://tensolite.com/noticias/${noticia.title}`} />
          <meta property="twitter:title" content={noticia?.title} />
          <meta property="twitter:description" content={noticia?.top} />
          <meta property="twitter:image" content="/logo192.png" />

          {/* End Google Tag Manager (noscript) */}
          <script type="application/ld+json">
            {`
            "@context": "https://schema.org",
            "@type": "article" ,
            "author": "Tensolite SA",
            "name": ${noticia.title},
            "description": ${noticia.top},
            "about": ${noticia.category},           
       `}
          </script>
        </Helmet>
      </HelmetProvider>

      <Suspense fallback={<div> </div>}>
        <NavTensoNews />

        {/* BODY */}
        <div id="img-noticia" className="block-img-responsive">
          <picture>
            <source
              media="(orientation: portrait) and (max-width: 1199px)"
              className="height-img-cover img-responsive"
              srcSet={noticia.imageCover_tablet ? noticia.imageCover_tablet[0]?.url : ""}
              alt={noticia.imageCover_tablet ? noticia.imageCover_tablet[0]?.alt : noticia?.title}
              title={noticia?.title}
            />
            <img
              src={noticia.imageCover ? noticia.imageCover[0]?.url : ""}
              className="height-img-cover img-responsive"
              alt={noticia.imageCover ? noticia.imageCover[0]?.alt : noticia?.title}
              title={noticia?.title}
            />
          </picture>
        </div>
        <div className="container">
          <section className="info-producto">
            <div id="tarjeta-azul">
              <div className="texto-slider mb-3">
                <p>{noticia.category}</p>
              </div>
              <div className="title-info-noticias">
                <h3>{noticia.title} </h3>
              </div>
              <Divider id="divisor"></Divider>
              {noticia?.read_time && (
                <article className="seccion-vistas-noticias seccion-redes-card pb-2 color-white">
                  <BookmarkBorderIcon id="icon-redes-noticias" />
                  {noticia?.read_time} min lectura
                </article>
              )}
            </div>

            <div className="card-ventajas">
              <p dangerouslySetInnerHTML={{ __html: noticia.top }}></p>
            </div>
          </section>
          <Divider />
          <ShareSocial noticia={noticia} />

          <div>
            <div id="noticia-video">
              <div>
                <div className="">
                  <article className="container info-card mt-3">
                    <p
                      id="body-noticia"
                      className="news-tiny-editor"
                      dangerouslySetInnerHTML={{ __html: noticia.body }}
                    ></p>
                  </article>
                </div>
                <div
                  className={`${
                    noticia?.moduloTextImage === true ? "d-flex" : ""
                  } cards-noticias display-none `}
                >
                  <article className="uno">
                    <picture>
                      <source
                        className="img-card-noticia"
                        srcSet={noticia.imageBody ? noticia.imageBody[0]?.url : ""}
                        alt={noticia.imageBody ? noticia.imageBody[0]?.alt : noticia?.title}
                        title={noticia?.title}
                      />
                      <img
                        src={noticia.imageBody ? noticia.imageBody[0]?.url : ""}
                        alt={noticia.imageBody ? noticia.imageBody[0]?.alt : noticia?.title}
                        title={noticia?.title}
                        className="img-card-noticia"
                      />
                    </picture>
                  </article>
                  <article className="container info-card dos">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: noticia?.footer_news
                      }}
                    ></p>
                  </article>
                </div>
              </div>
              {noticia.lastNewsVideos !== false && (
                <div className="text-video">
                  <div className="titulo-seccion-video noticias-hr">
                    <p className="titulo-roboto">Últimos videos</p>
                  </div>
                  <div className="video-destacado">
                    <div id="videos-recomendados">
                      {loading ? (
                        <>
                          <CardVideo loading={loading} />
                          <CardVideo loading={loading} />
                          <CardVideo loading={loading} />
                        </>
                      ) : (
                        <>
                          {newsVideo
                            .slice(0, 3)
                            .map(
                              (noticia, index) =>
                                noticia.deleted === false &&
                                noticia.visible === true &&
                                noticia.publish === true && (
                                  <CardVideo loading={loading} key={index} noticia={noticia} />
                                )
                            )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {noticia.newsCategory !== false && (
              <div className="">
                <div className="seccion-mas-noticias">
                  <div className="title-noticias ">
                    <h3>Últimas noticias de {noticia.category}</h3>
                  </div>
                </div>
                <div className="seccion-cards-noticias ">
                  <div id="seccion-noticas">
                    <div className="">
                      <div className="masonry mansory_tensoblog_replica">
                        {loading ? (
                          <>
                            <CardNews loading={true} tensoblog={true} />
                            <CardNews loading={true} tensoblog={true} />
                          </>
                        ) : (
                          <>
                            {news.map(
                              (noticia, index) =>
                                noticia.category === busqueda &&
                                noticia.deleted === false &&
                                noticia.visible === true &&
                                noticia.publish === true && (
                                  <CardNews key={index} noticia={noticia} />
                                )
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Suspense>
    </>
  );
};
export default Noticias;
